export class SC_IVRCompliance {
    static readonly NULL = 0;
    static readonly ALL = 1;
    static readonly PENDING_CREW_ASSIGNMENT = 7;
    static readonly FUTURE = 8;
    static readonly ON_SITE = 2;
    static readonly ETA_MISSED = 3;
    static readonly NO_IVR = 4;
    static readonly NO_WORK = 5;
    static readonly RESCHEDULED = 9;
    static readonly COMPLETED = 6;

    constructor(private service: number = SC_IVRCompliance.NULL) { }

    static fromAPI(apiValue: number): SC_IVRCompliance {
        switch (apiValue) {
            case SC_IVRCompliance.ALL:
                return new SC_IVRCompliance(SC_IVRCompliance.ALL);
            case SC_IVRCompliance.PENDING_CREW_ASSIGNMENT:
                return new SC_IVRCompliance(SC_IVRCompliance.PENDING_CREW_ASSIGNMENT);
            case SC_IVRCompliance.ON_SITE:
                return new SC_IVRCompliance(SC_IVRCompliance.ON_SITE);
            case SC_IVRCompliance.NO_IVR:
                return new SC_IVRCompliance(SC_IVRCompliance.NO_IVR);
            case SC_IVRCompliance.ETA_MISSED:
                return new SC_IVRCompliance(SC_IVRCompliance.ETA_MISSED);
            case SC_IVRCompliance.NO_WORK:
                return new SC_IVRCompliance(SC_IVRCompliance.NO_WORK);
            case SC_IVRCompliance.RESCHEDULED:
                return new SC_IVRCompliance(SC_IVRCompliance.RESCHEDULED);
            case SC_IVRCompliance.COMPLETED:
                return new SC_IVRCompliance(SC_IVRCompliance.COMPLETED);
            default:
                return new SC_IVRCompliance();
        }
    }

    is(type: number): boolean {
        return this.service === type;
    }

    toAPI(): number {
        return this.service;
    }

    clone(): SC_IVRCompliance {
        return new SC_IVRCompliance(this.service);
    }

    /**
     * Merges another SC_IVRCompliance object into this one, replacing null fields
     */
    merge(other: SC_IVRCompliance): SC_IVRCompliance {
        if (other.service !== SC_IVRCompliance.NULL) {
            this.service = other.service;
        }

        return this;
    }

    static readonly ivrCompliance = [
        { key: SC_IVRCompliance.ALL, display: "All" },
        // IVR Complete
        // IVR Active/On Site
        { key: SC_IVRCompliance.PENDING_CREW_ASSIGNMENT, display: <><div className="service-icon-pending-assign"/> <span>Pending Crew Assign</span></> },
        { key: SC_IVRCompliance.ON_SITE, display: <><div className="service-icon-in-progress"/> <span>Active/On Site</span></> },
        // Break out to "IVR Late" and "IVR Missed/Force Close Needed"
        { key: SC_IVRCompliance.ETA_MISSED, display: <><div className="service-icon-eta-missed"/> <span>ETA Missed</span></> },
        // Break out into 4: all failures, then each failure
        { key: SC_IVRCompliance.NO_IVR, display: <><div className="service-icon-forced"/> <span>Force Closed: No IVR</span></> },
        { key: SC_IVRCompliance.NO_WORK, display: <><div className="service-icon-forced-missed"/> <span>Missed</span></> },
        { key: SC_IVRCompliance.RESCHEDULED, display: <><div className="service-icon-forced-reschedule"/> <span>Rescheduled</span></> },
        // Missed budget
        { key: SC_IVRCompliance.COMPLETED, display: <><div className="service-icon-completed"/> <span>Completed</span></> },
    ];

    static readonly simpleIVRCompliance = [
        { key: SC_IVRCompliance.ALL, display: "All" },
        // IVR Complete
        // IVR Active/On Site
        { key: SC_IVRCompliance.PENDING_CREW_ASSIGNMENT, display: "Pending Crew Assign" },
        { key: SC_IVRCompliance.ON_SITE, display: "Active/On Site" },
        // Break out to "IVR Late" and "IVR Missed/Force Close Needed"
        { key: SC_IVRCompliance.ETA_MISSED, display: "ETA Missed" },
        // Break out into 4: all failures, then each failure
        { key: SC_IVRCompliance.NO_IVR, display: "Force Closed: No IVR" },
        { key: SC_IVRCompliance.NO_WORK, display: "Missed" },
        { key: SC_IVRCompliance.RESCHEDULED, display: "Reschedule" },
        // Missed budget
        { key: SC_IVRCompliance.COMPLETED, display: "Completed" },
    ];

    toString(): string {
        switch (this.service) {
            case SC_IVRCompliance.PENDING_CREW_ASSIGNMENT:
                return "Pending Crew Assign";
            case SC_IVRCompliance.ETA_MISSED:
                return "IVR Missed";
            case SC_IVRCompliance.NO_WORK:
                return "No Work";
            case SC_IVRCompliance.RESCHEDULED:
                return "Rescheduled";
            case SC_IVRCompliance.NO_IVR:
                return "No IVR";
            case SC_IVRCompliance.ON_SITE:
                return "On Site";
            case SC_IVRCompliance.ALL:
                return "All";
            case SC_IVRCompliance.COMPLETED:
                return "Completed";
            default:
                return "UNKNOWN";
        }
    }

    get className() {
        switch (this.service) {
            case SC_IVRCompliance.COMPLETED:
                return "service-icon-completed";
            case SC_IVRCompliance.NO_WORK:
                return "service-icon-forced-missed";
            case SC_IVRCompliance.RESCHEDULED:
                return "service-icon-forced-reschedule";
            case SC_IVRCompliance.NO_IVR:
                return "service-icon-forced";
            case SC_IVRCompliance.ON_SITE:
                return "service-icon-in-progress";
            case SC_IVRCompliance.ETA_MISSED:
                return "service-icon-eta-missed";
            case SC_IVRCompliance.FUTURE:
                return "service-icon-in-future";
            case SC_IVRCompliance.PENDING_CREW_ASSIGNMENT:
                return "service-icon-pending-assign";
        }

        return "";
    }
}
